// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kVdqbn {
  margin: 0;
  height: 100vh;
  padding: 0 !important;
  position: fixed !important;
  right: 0;
  top: 0;
}

.daTTxe {
  margin: 0 auto;
  max-width: var(--grid-breakpoint-l);
  height: 100vh;
  transform: none !important;
}

.J2mO2S {
  margin: 0;
  margin-left: auto;
  max-width: 400px;
  height: 100vh;
  border: none;
  border-radius: 0;
  background-color: var(--surface-neutral-white);
  display: flex;
  flex-direction: column;
}

.gz0nig {
  padding: var(--spacing-3) var(--spacing-1-5) 0;
  border: none;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  flex-shrink: 0;
}

.Hhz9Wj {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.r2F_Sz {
  background: none;
  border: none;
  padding: var(--spacing-0-5);
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: calc(-1 * var(--spacing-0-5));
}

.r2F_Sz img {
  width: 16px;
  height: 16px;
}

.xoxrLP {
  padding: var(--spacing-3);
  overflow-y: auto;
  min-height: 0;
  flex: 1;
}

.JB1ktK {
  --toggle-track-off: var(--surface-neutral-silver, #cccccc);
  --toggle-knob-off: var(--on-surface-neutral-white, #ffffff);
  --toggle-check-off: var(--surface-neutral-silver, #cccccc);
  --toggle-knob-on: var(--on-surface-neutral-white, #ffffff);

  min-height: 57px;
  padding-bottom: var(--spacing-2);
  border-bottom: 1px solid var(--stroke-neutral-subtle);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--spacing-2);
}

.utX9nI {
  width: 40px;
  height: 24px;
  margin-top: var(--spacing-1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.b8BbKR {
  max-width: 173px;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.Xiu93a {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  line-height: var(--line-height-140);
  color: var(--text-neutral-dark);
}

.YoYGli {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

.VhHYop {
  z-index: 1060;
}

.yBPfN3 {
  background-color: var(--neutral-dark-opacity-50) !important;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/ConfigurationPanel/ConfigurationPanel.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;EAC9C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,OAAO;AACT;;AAEA;EACE,0DAA0D;EAC1D,2DAA2D;EAC3D,0DAA0D;EAC1D,0DAA0D;;EAE1D,gBAAgB;EAChB,gCAAgC;EAChC,qDAAqD;EACrD,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2DAA2D;AAC7D","sourcesContent":[".modal {\n  margin: 0;\n  height: 100vh;\n  padding: 0 !important;\n  position: fixed !important;\n  right: 0;\n  top: 0;\n}\n\n.modalDialog {\n  margin: 0 auto;\n  max-width: var(--grid-breakpoint-l);\n  height: 100vh;\n  transform: none !important;\n}\n\n.modalContent {\n  margin: 0;\n  margin-left: auto;\n  max-width: 400px;\n  height: 100vh;\n  border: none;\n  border-radius: 0;\n  background-color: var(--surface-neutral-white);\n  display: flex;\n  flex-direction: column;\n}\n\n.modalHeader {\n  padding: var(--spacing-3) var(--spacing-1-5) 0;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  flex-shrink: 0;\n}\n\n.modalTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.backButton {\n  background: none;\n  border: none;\n  padding: var(--spacing-0-5);\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin: calc(-1 * var(--spacing-0-5));\n}\n\n.backButton img {\n  width: 16px;\n  height: 16px;\n}\n\n.modalBody {\n  padding: var(--spacing-3);\n  overflow-y: auto;\n  min-height: 0;\n  flex: 1;\n}\n\n.configurationItem {\n  --toggle-track-off: var(--surface-neutral-silver, #cccccc);\n  --toggle-knob-off: var(--on-surface-neutral-white, #ffffff);\n  --toggle-check-off: var(--surface-neutral-silver, #cccccc);\n  --toggle-knob-on: var(--on-surface-neutral-white, #ffffff);\n\n  min-height: 57px;\n  padding-bottom: var(--spacing-2);\n  border-bottom: 1px solid var(--stroke-neutral-subtle);\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--spacing-2);\n}\n\n.toggleSlot {\n  width: 40px;\n  height: 24px;\n  margin-top: var(--spacing-1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.labelContainer {\n  max-width: 173px;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.label {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-140);\n  color: var(--text-neutral-dark);\n}\n\n.informationIcon {\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n}\n\n.errorToast {\n  z-index: 1060;\n}\n\n.backdrop {\n  background-color: var(--neutral-dark-opacity-50) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `kVdqbn`,
	"modalDialog": `daTTxe`,
	"modalContent": `J2mO2S`,
	"modalHeader": `gz0nig`,
	"modalTitle": `Hhz9Wj`,
	"backButton": `r2F_Sz`,
	"modalBody": `xoxrLP`,
	"configurationItem": `JB1ktK`,
	"toggleSlot": `utX9nI`,
	"labelContainer": `b8BbKR`,
	"label": `Xiu93a`,
	"informationIcon": `YoYGli`,
	"errorToast": `VhHYop`,
	"backdrop": `yBPfN3`
};
module.exports = ___CSS_LOADER_EXPORT___;
